import React, { useState, useEffect } from "react";
import {
  Breadcrumb,
  Divider,
  Button,
  Card,
  Collapse,
  Form,
  Input,
  Row,
  Col,
  Popconfirm,
  Space,
  Badge,
  DatePicker,
  Select,
} from "antd";
import * as Icon from "react-feather";
import { useDispatch } from 'react-redux';
import appLoaderAction from '../../redux/action/app-loader-action';
import notifyUtitls from '../../utils/notify-utils';
import CustomTable from '../../components/table/custom-table';
import { useCreatedSort, withCreatedColumn } from '../../shared/functional/created-sort';
import moment from 'moment';
import AddEditActivityDialog from "./AddEditActivityDialog";
import activityService from '../../services/activity-service';
import constantService from "../../services/constant-service";
import { nullFormat } from "numeral";
import userService from "../../services/user-service";

const { RangePicker } = DatePicker;
const { Panel } = Collapse;
const { Option } = Select;

const Activity = () => {
  const dispatch = useDispatch();
  const [isShowAddFileDialog, setIsShowAddFileDialog] = useState(false);
  const [editData, setEditData] = useState(null);
  const [condition, setCondition] = useState({
    title: null,
    startDate: null,
    endDate: null,
    createBy: null,
    status: null
  });
  const [dataList, setDataList] = useState(null);
  const [pagination, setPagination] = useState({ currentPage: 1, rowPerPage: 10, rowCount: 0 });
  const [groupMenu, setGroupMenu] = useState(null);
  const [constant, setConstant] = useState({});
  const [userList, setUserList] = useState([]);


  /*
    NMU-580: the วันที่/เวลาสร้าง column and the sort behind it.

    The server does the ordering — this table shows one page of many — so a
    click re-runs the search in the new order, back on page 1: the newest
    record is not on page 3 of the same list read the other way round.
  */
  const { sort, createdColumn, onChangeTable } = useCreatedSort((next) =>
    doSearch(1, { condition, groupMenu, sort: next }));

  const columns = [
    {
      key: 'title',
      align: 'left',
      title: 'ชื่อกิจกรรม',
      dataIndex: 'title',
      render: (text) => (
        <span>{text.titleTH}</span>
      )
    },
    {
      title: "วันที่จัดกิจกรรม",
      dataIndex: "date",
      key: "date",
      render: (text) => {
        return moment(text).format('DD MMMM YYYY hh:mm:ss')
      }
    },
    {
      title: "จำนวนผู้เข้าชม",
      dataIndex: "totalView",
      key: "totalView",
    },
    {
      title: "สถานะ",
      dataIndex: "status",
      key: "status",
      render: (status) => (
        status ? <Badge color="#4A9A0F" className="text-nowrap" text="Online" /> :
          <Badge color="#C0C0C0" className="text-nowrap" text="Offline" />
      ),
    },
    {
      title: "ผู้บันทึก",
      key: "createBy",
      dataIndex: "createBy",
      render: (createBy) => {
        let check = userList.find((user) => createBy === user.userId);
        if (check) {
          return (`${check.profile?.firstName} ${check.profile?.lastName}`)
        }else{
          return (`undefined`)
        }
      },
    },
    {
      title: "ผู้แก้ไข",
      dataIndex: "updateBy",
      key: "updateBy",
      render: (updateBy) => {
        let check = userList.find((user) => updateBy === user.userId);
        if (check) {
          return (`${check.profile?.firstName} ${check.profile?.lastName}`)
        }else{
          return (`undefined`)
        }
      },
    },

    {
      title: "ดำเนินการ",
      key: "action",
      render: ({ activityId }) => (
        <Space size="middle">
          <label style={{ cursor: 'pointer' }} onClick={() => onClickEdit(activityId)} className="pe-3 border-end">
            <Icon.Edit size={18} />
          </label>

          <Popconfirm
            title="ยืนยันการลบข้อมูล ?"
            onConfirm={() => onConfirmDelete(activityId)}
            okText="ยืนยัน"
            cancelText="ยกเลิก" >
            <label style={{ cursor: 'pointer' }}>
              <Icon.Trash size={18} />
            </label>
          </Popconfirm>
        </Space>
      ),
    },
  ];

  useEffect(() => {
    async function initData() {
      const response = await constantService.getConstants();
      let constant = response.constants

      setConstant(constant);

      const responseUser = await userService.search();
      setUserList(responseUser.list);
    }
    initData();
    doSearch();
    if (editData) {
      onEdit(editData);
    }
  }, [editData]);

  /**
   * @param currentPage page to land on, 1 to start over.
   * @param overrides   NMU-529: search with these filters instead of the ones in
   *   state. setCondition only takes effect on the next render, so a caller that
   *   resets the filters and searches in the same handler would otherwise re-run
   *   the search it just cleared.
   */
  const doSearch = async (currentPage, overrides) => {
    try {
      const activeSort = overrides && overrides.sort ? overrides.sort : sort;
      const activityPaginate = {
        ...pagination,
        currentPage: currentPage ? currentPage : pagination.currentPage,
        // NMU-580: the order travels with the page — see created-sort.js.
        ...activeSort,
      };

      dispatch(appLoaderAction.enable());

      const activeCondition = overrides ? overrides.condition : condition;
      const activeGroupMenu = overrides ? overrides.groupMenu : groupMenu;

      // NMU-579: keywordList is no longer a search condition. The backend skips
      // the criterion when it is absent, so nothing else changes.
      const activityCondition = {
        title: activeCondition.title,
        startDate: activeCondition.startDate,
        endDate: activeCondition.endDate,
        groupMenuList: activeGroupMenu ? [activeGroupMenu] : null,
        createBy: activeCondition.createBy,
        status: activeCondition.status
      };
      const result = await activityService.search(activityCondition, activityPaginate);
      // setDataList(result.list);
      setDataList([
        ...result.list
      ]);
      setPagination(result.pagination ? result.pagination : activityPaginate);
      dispatch(appLoaderAction.disale());
    } catch (err) {
      dispatch(appLoaderAction.disale());
      dispatch(notifyUtitls.error(err));
    }
  };

  const onChangeCondition = (event) => {
    const { name, value } = event.target;
    setCondition({ ...condition, [name]: value });
  }

  /**
   * NMU-529: clearing the filters has to re-run the search, not just empty the
   * inputs — otherwise the table keeps showing the previous result set while the
   * form claims no filter is applied. Back to page 1, since the record the user
   * was looking at on page 3 of a filtered list is somewhere else entirely in
   * the full one.
   */
  const onClearSearch = () => {
    const cleared = {
      title: null,
      startDate: null,
      endDate: null,
      status: null,
      groupMenuList: null,
      createBy: null,
    };
    setCondition(cleared);
    setGroupMenu(null);
    doSearch(1, { condition: cleared, groupMenu: null });
  }

  const handleChangeRangePicker = (values) => {
    if (values) {
      setCondition({
        ...condition,
        startDate: values[0].toDate().getTime(),
        endDate: values[1].toDate().getTime()
      });
    } else {
      setCondition({
        ...condition,
        startDate: null,
        endDate: null,
      });
    }
  };

  const onChangePage = (currentPage) => {
    doSearch(currentPage);
  }

  const onAdd = () => {
    setEditData(null);
    setIsShowAddFileDialog(true);
  };

  const onClickEdit = async (id) => {
    try {
      dispatch(appLoaderAction.enable());
      const editData = await activityService.getById({ id: id });
      onEdit(editData.bean);
      dispatch(appLoaderAction.disale());
    } catch (err) {
      dispatch(appLoaderAction.disale());
      notifyUtitls.error(err);
    }
  }

  const onEdit = (data) => {
    setEditData(data);
    setIsShowAddFileDialog(true);
  }

  const onSaveComplete = () => {
    setEditData(null);
    setIsShowAddFileDialog(false);
    doSearch();
  };

  const onCancel = () => {
    setIsShowAddFileDialog(false);
    setEditData(null);
  };

  const onConfirmDelete = (id) => {
    onDelete(id);
  }

  const onDelete = async (id) => {
    try {
      dispatch(appLoaderAction.enable());
      await activityService.remove({ deleteIds: [id] });
      dispatch(appLoaderAction.disale());
      notifyUtitls.deleted('สำเร็จ', 'ลบข้อมูลสำเร็จ');
      doSearch();
    } catch (err) {
      dispatch(appLoaderAction.disale());
      notifyUtitls.error(err);
    }
  };

  const renderGroupMenuOption = () => {
    return constant.menuGroupType?.map((item) => {
      return (
        <Select.Option value={item.value} key={item.labelTh}>
          {item.labelTh}
        </Select.Option>
      );
    });
  };

  const renderOptionUser = () => {
    return userList?.map((item) => {
      if (item?.profile) {
        const profile = item.profile;
        return (
          <Select.Option value={item.userId} key={item.userId}>
            {`${profile.firstName} ${profile.lastName}`}
          </Select.Option>
        );
      } else {
        return null
      }
    });
  };

  const onChangeSelect = (name) => {
    return (value) => {
      setCondition({ ...condition, [name]: value });
    };
  }

  return (
    <div>
      <h2 className="color-primary-title">กิจกรรม</h2>
      <Breadcrumb>
        <Breadcrumb.Item>การจัดการเนื้อหา</Breadcrumb.Item>
        <Breadcrumb.Item>กิจกรรม</Breadcrumb.Item>
      </Breadcrumb>
      <Divider className="mt-2 mb-4" />
      <div className="d-flex justify-content-between">
        <Button type="primary" onClick={() => onAdd()}>
          <Icon.Plus className="me-1" size={18} /> เพิ่มกิจกรรม
        </Button>
      </div>
      <Card className="mt-4" bordered={false}>
        <Collapse className="mb-4" defaultActiveKey={["1"]}>
          <Panel header="ตัวกรอง" key="1">
            <div>
              <Form layout="vertical">
                <Row gutter={20}>
                  <Col span={8}>
                    <Form.Item label="ชื่อกิจกรรม" className="mb-0">
                      <Input
                        name="title"
                        value={condition.title}
                        onChange={onChangeCondition}
                      />
                    </Form.Item>
                  </Col>
                  <Col span={8}>
                    <Form.Item name="Activedate" label="วันที่" className="mb-0">
                      <RangePicker
                        className="w-100"
                        defaultValue={null}
                        onChange={handleChangeRangePicker}
                        value={[
                          condition.startDate
                            ? moment(condition.startDate)
                            : null,
                          condition.endDate
                            ? moment(condition.endDate)
                            : null
                        ]}
                      />
                    </Form.Item>
                  </Col>
                  {/* NMU-579: no คีย์เวิร์ด filter here. Keywords are something
                      an editor sets on an activity in the add/edit dialog — they
                      were never a useful way to find one. The dialog keeps its
                      keyword input. */}
                  <Col span={8}>
                    <Form.Item label="กลุ่มผู้ใช้งาน" className="mb-0">
                      <Select customWidth="100%"
                        name="groupMenuList"
                        onChange={(value) => setGroupMenu(value)}
                        value={groupMenu} >
                        <Select.Option value={null}>ทั้งหมด</Select.Option>
                        {renderGroupMenuOption()}
                      </Select>
                    </Form.Item>
                  </Col>
                  <Col span={8}>
                    <Form.Item label="ผู้บันทึก" className="mb-0">
                      <Select
                        showSearch
                        placeholder="Search to Select"
                        optionFilterProp="children"
                        allowClear
                        filterOption={(input, option) =>
                          option.children.toLowerCase().indexOf(input.toLowerCase()) >= 0
                        }
                        filterSort={(optionA, optionB) =>
                          optionA.children.toLowerCase().localeCompare(optionB.children.toLowerCase())
                        }
                        value={condition.createBy}
                        onChange={onChangeSelect('createBy')}
                      >
                        {renderOptionUser()}

                      </Select>
                    </Form.Item>
                  </Col>
                  <Col span={8}>
                    <Form.Item label="สถานะ" className="mb-0">
                      <Select name="status" value={condition.status} onChange={onChangeSelect('status')}>
                        <Option value={null}>All</Option>
                        <Option value={true}>Online</Option>
                        <Option value={false}>Offline</Option>
                      </Select>
                    </Form.Item>
                  </Col>
                </Row>
                <Row gutter={20}>
                  <Col className="mt-4">
                    <Button type="primary" className="w-100" onClick={() => doSearch()}>
                      <Icon.Search className="me-1" size={18} /> ค้นหา
                    </Button>
                  </Col>
                  <Col className="mt-4">
                    <Button className="btn-gray" onClick={() => onClearSearch()}>ล้างค่า</Button>
                  </Col>
                </Row>
              </Form>
            </div>
          </Panel>
        </Collapse>
        <CustomTable
          rowKey="activityId"
          tableName="activityIdTable"
          columns={withCreatedColumn(columns, createdColumn)}
          onChangeTable={onChangeTable}
          data={dataList}
          scroll={{ x: true }}
          isPagination={true}
          onChangePage={onChangePage}
          currentPage={pagination.currentPage}
          pageSize={pagination.rowPerPage}
          totalRecord={pagination.rowCount}
        />
      </Card>

      <AddEditActivityDialog
        isShow={isShowAddFileDialog}
        editData={editData}
        onCancel={onCancel}
        renderGroupMenuOption={renderGroupMenuOption}
        onSaveComplete={onSaveComplete}></AddEditActivityDialog>

    </div>
  );
};

export default Activity;
